/* eslint-disable */
export default {
  dialer: 'Wählfeld',
  allCalls: 'Alle Anrufe',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
